import { render, staticRenderFns } from "./BlockMap.vue?vue&type=template&id=4004095e&"
import script from "./BlockMap.vue?vue&type=script&lang=js&"
export * from "./BlockMap.vue?vue&type=script&lang=js&"
import style0 from "./BlockMap.vue?vue&type=style&index=0&id=4004095e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports